import React from "react";

const IconFacebook = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={25}
      height={26}
      viewBox="0 0 25 26"
      fill="none"
      {...props}
    >
      <mask
        id="mask0_292_316"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={25}
        height={25}
      >
        <path
          d="M24.1094 0.782959H0.109375V24.783H24.1094V0.782959Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_292_316)">
        <path
          d="M23.9886 12.4385C23.9886 10.2046 23.3262 8.02103 22.0852 6.16373C20.8442 4.30643 19.0804 2.85883 17.0165 2.004C14.9528 1.14918 12.682 0.92552 10.4911 1.36131C8.3003 1.79709 6.28787 2.87275 4.70836 4.45226C3.12885 6.03177 2.05319 8.04419 1.61741 10.235C1.18162 12.4259 1.40528 14.6968 2.2601 16.7605C3.11493 18.8242 4.56252 20.5882 6.41984 21.8291C8.27714 23.0702 10.4607 23.7326 12.6945 23.7326C15.689 23.7297 18.56 22.5388 20.6774 20.4213C22.7949 18.304 23.9857 15.433 23.9886 12.4385ZM13.3589 22.3817V14.8744H16.2378C16.414 14.8744 16.583 14.8044 16.7075 14.6799C16.8321 14.5553 16.9022 14.3863 16.9022 14.2101C16.9022 14.0339 16.8321 13.8649 16.7075 13.7403C16.583 13.6157 16.414 13.5457 16.2378 13.5457H13.3589V10.6668C13.3618 10.1391 13.5727 9.63382 13.9458 9.26068C14.3189 8.88752 14.8242 8.6766 15.3519 8.67369H17.1235C17.2997 8.67369 17.4687 8.60371 17.5934 8.47911C17.7179 8.35452 17.7879 8.18553 17.7879 8.00934C17.7879 7.83314 17.7179 7.66415 17.5934 7.53957C17.4687 7.41498 17.2997 7.34498 17.1235 7.34498H15.3519C14.4718 7.3479 13.6286 7.69881 13.0063 8.32113C12.384 8.94347 12.0331 9.78669 12.0301 10.6668V13.5457H9.15125C8.97506 13.5457 8.80607 13.6157 8.68149 13.7403C8.5569 13.8649 8.4869 14.0339 8.4869 14.2101C8.4869 14.3863 8.5569 14.5553 8.68149 14.6799C8.80607 14.8044 8.97506 14.8744 9.15125 14.8744H12.0301V22.3817C9.45046 22.2093 7.03874 21.041 5.30429 19.1238C3.56982 17.2065 2.64842 14.6901 2.73465 12.1061C2.82088 9.52206 3.908 7.07272 5.76642 5.27529C7.62484 3.47785 10.1091 2.47304 12.6945 2.47304C15.2799 2.47304 17.7642 3.47785 19.6226 5.27529C21.4811 7.07272 22.5681 9.52206 22.6544 12.1061C22.7406 14.6901 21.8192 17.2065 20.0847 19.1238C18.3502 21.041 15.9385 22.2093 13.3589 22.3817Z"
          fill="#F5FAFA"
        />
      </g>
    </svg>
  );
};

export default IconFacebook;
